<template>
  <div class="main-width">
    <div
      style="
        display: flex;
        justify-content: space-around;
        width: 85%;
        margin: 0 auto;
        position: relative;
        top: 179px;
      "
    >
      <div
        @click="activeName = 'drug'"
        :class="[
          'tag-normal',
          'tag-drug',
          activeName == 'drug' ? 'active' : 'deactive',
        ]"
      >
        <div class="tag-icon">
          <i class="icon iconfont icon-drug2" style="font-size: 28px"></i>
        </div>
        <div class="tag-title">RP Drug</div>
        <div class="tag-icon-hover">
          <i class="fa fa-hand-o-up" aria-hidden="true"></i>
        </div>
      </div>

      <div
        @click="activeName = 'radionuclide'"
        :class="[
          'tag-normal',
          'tag-radionuclide',
          activeName == 'radionuclide' ? 'active' : 'deactive',
        ]"
      >
        <div class="tag-icon">
          <i class="icon iconfont icon-radionuclide1" style="font-size: 28px"></i>
        </div>
        <div class="tag-title">Radionuclide</div>
        <div class="tag-icon-hover">
          <i class="fa fa-hand-o-up" aria-hidden="true"></i>
        </div>
      </div>
      <div
        @click="activeName = 'target'"
        :class="[
          'tag-normal',
          'tag-target',
          activeName == 'target' ? 'active' : 'deactive',
        ]"
      >
        <div class="tag-icon">
          <i class="icon iconfont icon-target1" style="font-size: 28px"></i>
        </div>
        <div class="tag-title">Target</div>
        <div class="tag-icon-hover">
          <i class="fa fa-hand-o-up" aria-hidden="true"></i>
        </div>
      </div>


      <div
        @click="activeName = 'disease'"
        :class="[
          'tag-normal',
          'tag-disease',
          activeName == 'disease' ? 'active' : 'deactive',
        ]"
      >
        <div class="tag-icon">
          <i
            class="icon iconfont icon-cancer2"
            style="font-size: 28px"
          ></i>
        </div>
        <div class="tag-title">Disease</div>
        <div class="tag-icon-hover">
          <i class="fa fa-hand-o-up" aria-hidden="true"></i>
        </div>
      </div>

    </div>

    <div v-show="activeName == 'drug'" style="margin-top: -85px">
      <SearchDrugPage></SearchDrugPage>
    </div>
    <div v-show="activeName == 'radionuclide'" style="margin-top: -85px">
      <SearchRadionuclidePage></SearchRadionuclidePage>
    </div>
    <div v-show="activeName == 'target'" style="margin-top: -85px">
      <SearchTargetPage></SearchTargetPage>
    </div>
    <div v-show="activeName == 'disease'" style="margin-top: -85px">
      <SearchDiseasePage></SearchDiseasePage>
    </div>
  </div>
</template>

<script>
import SearchDiseasePage from "@/views/searchPage/SearchDiseasePage.vue";
import SearchDrugPage from "@/views/searchPage/SearchDrugPage.vue";
import SearchRadionuclidePage from "@/views/searchPage/SearchRadionuclidePage.vue";
import SearchTargetPage from "@/views/searchPage/SearchTargetPage.vue";
export default {
  name: "HomeView",
  data() {
    return {
      activeName: "drug",
    };
  },

  methods: {},
  components: {
    SearchDiseasePage,
    SearchDrugPage,
    SearchRadionuclidePage,
    SearchTargetPage,
  },
  beforeMount() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
@color-drug: #0071c1;
@color-radionuclide: #e5795c;
@color-target: #548235;
@color-disease: #d04c64;

/deep/.home-height {
  height: 200px !important;
}
.tag-normal:hover {
  .tag-icon-hover {
    -webkit-animation: 0.5s rotate-move ease-out forwards;
    animation: 0.5s rotate-move ease-out forwards;
    transform: rotate(0deg);
  }
}

@keyframes rotate-move {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.tag-normal {
  display: flex;
  height: 48px;

  cursor: pointer;
  border-radius: 30px;
  .tag-icon {
    margin: 4px 2px 4px 4px;
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: 25px;
    margin-left: 4px;
    display: flex;
  }
  .tag-icon-hover {
    margin-right: 18px;
    display: flex;
    .fa {
      font-size: 25px;
      margin: auto;
    }
  }
  .tag-title {
    margin: auto;
    font-size: 24px;
    padding-left: 18px;
    padding-right: 24px;
    width: 122px;
    text-align: center;
    // font-weight: bold;
  }
  .icon {
    margin: auto;
    font-size: 25px;
  }
}

.tag-drug {
  background: @color-drug;
  border: 2px solid @color-drug;
  color: @color-drug;
  .icon {
    color: @color-drug;
  }
}
.tag-radionuclide {
  background: @color-radionuclide;
  border: 2px solid @color-radionuclide;
  color: @color-radionuclide;
  .icon {
    color: @color-radionuclide;
  }
}
.tag-target {
  background: @color-target;
  border: 2px solid @color-target;
  color: @color-target;
  .icon {
    color: @color-target;
  }
}
.tag-disease {
  background: @color-disease;
  border: 2px solid @color-disease;
  color: @color-disease;
  .icon {
    color: @color-disease;
  }
}

.deactive {
  background: #eeeeee;
}
.active {
  color: #fff;
}
</style>
